import { Button, TextField } from '@mui/material';
import React, { useEffect } from 'react';

import VnModalBody from '@/modals/components/VnModalBody';
import VnModalFooter from '@/modals/components/VnModalFooter';
import { VNBaseModal } from '@/modals/VNBaseModal';

import usePrompt from '../../hooks/usePrompt';

interface IProps {
  value: string;
}

const FuelPrompt = ({ value }: IProps) => {
  const { onConfirm, onCancel } = usePrompt();
  const [open, setOpen] = React.useState(false);
  const [val, setVal] = React.useState(null);

  useEffect(() => {
    if (value) {
      setVal('');
      setOpen(true);
    }
  }, [value]);

  const handleConfirm = (event: React.SyntheticEvent | Event, reason?: string) => {
    setVal('');
    setOpen(false);
    onConfirm(val);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
    onCancel();
  };

  return (
    <VNBaseModal
      open={open}
      title={value}
      onClose={onCancel}
      // subTitle="Test"
    >
      <VnModalBody>
        <TextField defaultValue={val} onChange={(event) => setVal(event.target.value)} />
      </VnModalBody>
      <VnModalFooter
        right={
          <>
            {' '}
            <Button color="success" variant="contained" onClick={handleConfirm}>
              Ok
            </Button>
            <Button variant="contained" onClick={handleClose}>
              Cancel
            </Button>
          </>
        }
      />
    </VNBaseModal>
  );
};

export default FuelPrompt;
